import { Pills } from '@amelio/ui-library';

import { useAmelioTranslations } from '@/hooks';

/** Says the employee already holds the competency in their current profile. */
export const AlreadyHeldMention = () => {
    const { t } = useAmelioTranslations();

    return (
        <Pills
            variant={'default'}
            size={'sm'}
            className={'whitespace-nowrap'}
        >
            {t('competencies.competencyProfilesAdmin.selector.alreadyHeld')}
        </Pills>
    );
};
